// extracted by mini-css-extract-plugin
export default {"container":"buildersSharePage_container__a0nDa"};